import i18next from "translations/i18n";

// Times are also in isKAOpen.js

i18next.addResourceBundle(
  "de",
  "workingHours",
  {
    normal: "MO-FR: 9-20H, SA: 9-16H",
    narrow: "MO-FR: 9-20H<br />SA: 9-16Uhr",
    week: "MO-FR: 9:00 - 20:00 Uhr",
    weekend: "SA: 9:00 - 16:00 Uhr",
    open: "Jetzt erreichbar!",
    close: "Bald wieder verfügbar...",
    workingHours: "Öffnungszeiten",
  },
  true,
  true
);

i18next.addResourceBundle(
  "en",
  "workingHours",
  {
    normal: "Monday-Friday 9am-8pm, Saturday 9am-4pm",
    narrow: "Monday-Friday 9am-8pm<br />Saturday 9am-4pm",
    week: "MO-FR: 9am - 8pm",
    weekend: "SA: 9am - 4pm",
    open: "Now available!",
    close: "Soon available again...",
    workingHours: "Working hours",
  },
  true,
  true
);
